import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';

let hideStarted = false;

/** Auth 就緒後隱藏原生 Splash；可重複呼叫，只執行一次 */
export async function hideNativeSplashWhenReady(): Promise<void> {
  if (hideStarted || !Capacitor.isNativePlatform()) return;
  hideStarted = true;
  try {
    await SplashScreen.hide({ fadeOutDuration: 280 });
  } catch (error) {
    console.warn('[nativeSplash] hide failed:', error);
  }
}
